//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "PresseIndexPage",
  transition: "default",
  async asyncData({ $axios, params, error }) {
    try {
      const qs = require("qs");
      const query = qs.stringify(
        {
          // publicationState: "preview",
          filters: {
            slug: {
              $eq: "presse",
            },
          },
        },
        {
          encodeValuesOnly: true,
        }
      );
      // console.log("PRESSE QUERY: " + query);
      const presseSeiteData = await $axios.$get(
        `${process.env.api_url}/api/pages?${query}&populate=deep&locale=all`
      );
      const breakBlockData = await $axios.$get(
        `${process.env.api_url}/api/boxes-break-blocks?populate=deep&locale=all`
      );
      // console.log("PRESSE PARAMS: ", params);
      return {
        data: {
          presseSeiteData: presseSeiteData.data[0],
          breakBlockData:
            breakBlockData.data.length && breakBlockData.data[0].attributes,
        },
      };
    } catch (err) {
      error({
        statusCode: 404,
        message: "Page not found",
      });
    }
  },
  head() {
    return {
      title: `${this.data.presseSeiteData.attributes.title && this.data.presseSeiteData.attributes.title}`,
      meta: [
        { charset: "utf-8" },
        { name: "viewport", content: "width=device-width, initial-scale=1" },
        {
          hid: "description",
          name: "description",
          content:
            this.data.presseSeiteData.attributes.page_description &&
            this.data.presseSeiteData.attributes.page_description,
        },
        {
          hid: "og:title",
          property: "og:title",
          content: `${
            this.data.presseSeiteData.attributes.title && this.data.presseSeiteData.attributes.title
          }`,
        },
        {
          hid: "og:desc",
          name: "og:description",
          content:
            this.data.presseSeiteData.attributes.page_description &&
            this.data.presseSeiteData.attributes.page_description,
        },
        {
          hid: "og:url",
          property: "og:url",
          content: `${process.env.root_url + this.$route.path}`,
        },
        // twitter card
        {
          hid: "twitter:title",
          name: "twitter:title",
          content: `${
            this.data.presseSeiteData.attributes.title && this.data.presseSeiteData.attributes.title
          }`,
        },
        {
          hid: "twitter:url",
          name: "twitter:url",
          content: `${process.env.root_url + this.$route.path}`,
        },
        {
          hid: "twitter:description",
          name: "twitter:description",
          content:
            this.data.presseSeiteData.attributes.page_description &&
            this.data.presseSeiteData.attributes.page_description,
        },
      ],
      link: [
        {
          hid: "canonical",
          rel: "canonical",
          href: `${process.env.root_url + this.$route.path}`,
        },
      ],
    };
  },
};
